/* Voltaic theme scripts */
(function () {
  'use strict';
  const cfg = window.voltaic || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, moneyFormat: '${{amount}}', strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || cfg.moneyFormat || '${{amount}}';
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const type = m ? m[1] : 'amount';
    function num(n, precision, thousands, decimal) {
      const fixed = (n / 100).toFixed(precision);
      const parts = fixed.split('.');
      const int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? int + decimal + parts[1] : int;
    }
    let value;
    switch (type) {
      case 'amount_no_decimals': value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      default: value = num(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.voltaicFormatMoney = formatMoney;

  /* ---------- Theme toggle ---------- */
  function setTheme(next, persist = true) {
    const html = document.documentElement;
    html.classList.add('theme-transition');
    html.setAttribute('data-theme', next);
    if (persist) { try { localStorage.setItem('voltaic-theme', next); } catch (e) { /* private mode */ } }
    $$('[data-theme-toggle]').forEach(b => b.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false'));
    document.dispatchEvent(new CustomEvent('voltaic:theme', { detail: { theme: next } }));
    clearTimeout(setTheme._t);
    setTheme._t = setTimeout(() => html.classList.remove('theme-transition'), 500);
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-theme-toggle]');
    if (!b) return;
    const cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    setTheme(cur === 'dark' ? 'light' : 'dark');
  });
  $$('[data-theme-toggle]').forEach(b => b.setAttribute('aria-pressed', document.documentElement.getAttribute('data-theme') === 'dark' ? 'true' : 'false'));

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(html, ms = 3200) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span class="led"></span><span>' + html + '</span>';
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toastEl.classList.remove('is-visible'), ms);
  }
  window.voltaicToast = toast;

  /* ---------- Header state ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Search panel ---------- */
  const panel = $('[data-search-panel]');
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-toggle]');
    if (t && panel) {
      const open = panel.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) setTimeout(() => $('input', panel)?.focus(), 60);
      return;
    }
    if (panel && panel.classList.contains('is-open') && !e.target.closest('[data-search-panel]')) {
      panel.classList.remove('is-open');
      $$('[data-search-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });

  /* ---------- Mobile drawer ---------- */
  const drawer = $('[data-drawer]');
  function openDrawer() { if (!drawer) return; drawer.setAttribute('open', ''); document.body.style.overflow = 'hidden'; $('a, button', drawer)?.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.removeAttribute('open'); document.body.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-open]')) openDrawer();
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawer();
    if (panel) panel.classList.remove('is-open');
  });

  /* ---------- Reveal ---------- */
  const revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(el => io.observe(el));
  } else revealEls.forEach(el => el.classList.add('is-visible'));

  /* ---------- Hero entrance ---------- */
  requestAnimationFrame(() => requestAnimationFrame(() => $$('.hero').forEach(h => h.classList.add('is-ready'))));
  document.addEventListener('shopify:section:load', (e) => $$('.hero', e.target).forEach(h => h.classList.add('is-ready')));

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    if (!input) return;
    const min = parseInt(input.min || '1', 10) || 1;
    const step = parseInt(input.step || '1', 10) || 1;
    let v = parseInt(input.value || '1', 10) || min;
    v = b.hasAttribute('data-qty-plus') ? v + step : Math.max(min, v - step);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart helpers ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(el => { el.textContent = count > 0 ? count : ''; el.setAttribute('data-count', count); });
  }
  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    btn?.classList.add('btn--loading');
    try {
      const res = await fetch(cfg.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      const cart = await (await fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })).json();
      updateCartCount(cart.item_count);
      const name = data.product_title || 'Item';
      toast((cfg.strings.added || 'Added to cart') + ': ' + name + ' — <a href="' + cfg.routes.cart + '">' + (cfg.strings.viewCart || 'View cart') + '</a>');
      form.dispatchEvent(new CustomEvent('voltaic:added', { bubbles: true, detail: data }));
    } catch (err) {
      toast(err.message || 'Could not add to cart', 4000);
    } finally { btn?.classList.remove('btn--loading'); }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-product-form], [data-quick-add]')) return;
    if (!window.fetch) return; // fall back to a normal submit
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- Product page: variants, price, gallery ---------- */
  $$('[data-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', (e) => $$('[data-product]', e.target).forEach(initProduct));

  function initProduct(root) {
    const dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const form = $('[data-product-form]', root);
    const idInput = form && $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const btn = form && $('[data-add]', form);
    const btnLabel = btn && $('span', btn);
    const status = $('[data-availability]', root);
    const skuEl = $('[data-sku]', root);
    const optionInputs = $$('[data-option-input]', root);
    const hasOptions = optionInputs.length > 0;
    const strings = cfg.strings || {};

    function selected() {
      if (!hasOptions) return variants[0];
      const values = [];
      const groups = {};
      optionInputs.forEach(i => { if (i.checked) groups[i.dataset.position] = i.value; if (i.tagName === 'SELECT') groups[i.dataset.position] = i.value; });
      Object.keys(groups).sort().forEach(k => values.push(groups[k]));
      return variants.find(v => values.every((val, i) => v.options[i] === val));
    }
    function markAvailability() {
      // strike through values that have no available variant when combined with the other current choices
      const cur = selected();
      optionInputs.forEach(i => {
        if (i.tagName === 'SELECT') return;
        const pos = parseInt(i.dataset.position, 10) - 1;
        const combo = cur ? cur.options.slice() : [];
        combo[pos] = i.value;
        const match = variants.find(v => v.options.every((o, k) => k === pos || !cur || o === combo[k]) && v.options[pos] === i.value);
        const lbl = root.querySelector('label[for="' + i.id + '"]');
        if (lbl) lbl.classList.toggle('is-unavailable', !(match && match.available));
      });
    }
    function render() {
      const v = selected();
      markAvailability();
      if (!v) {
        if (btn) { btn.setAttribute('disabled', ''); if (btnLabel) btnLabel.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = '<span class="price__current">' + formatMoney(v.price) + '</span>' + (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '');
      }
      if (skuEl) skuEl.textContent = v.sku ? (strings.sku || 'Part no.') + ' ' + v.sku : '';
      if (btn) {
        if (v.available) { btn.removeAttribute('disabled'); if (btnLabel) btnLabel.textContent = strings.addToCart || 'Add to cart'; }
        else { btn.setAttribute('disabled', ''); if (btnLabel) btnLabel.textContent = strings.soldOut || 'Sold out'; }
      }
      if (status) {
        status.innerHTML = v.available
          ? '<span class="led"></span>' + (strings.inStock || 'In stock')
          : '<span class="led led--red"></span>' + (strings.soldOut || 'Sold out');
      }
      if (v.featured_media && v.featured_media.id) showSlide(root, String(v.featured_media.id));
      if (history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    optionInputs.forEach(i => i.addEventListener('change', render));
    render();

    // gallery
    $$('[data-thumb]', root).forEach(t => t.addEventListener('click', () => showSlide(root, t.dataset.thumb)));
  }
  function showSlide(root, id) {
    $$('[data-slide]', root).forEach(s => s.classList.toggle('is-active', s.dataset.slide === id));
    $$('[data-thumb]', root).forEach(t => t.setAttribute('aria-current', t.dataset.thumb === id ? 'true' : 'false'));
  }

  /* ---------- Cart page: auto-update quantities ---------- */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t); t = setTimeout(() => cartForm.submit(), 350);
    });
  }

  /* ---------- Collection filters (mobile) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-filters-toggle]');
    if (!b) return;
    const f = $('[data-filters]');
    if (!f) return;
    const open = f.classList.toggle('is-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  // sort select submits its form
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-sort]')) e.target.form?.submit();
  });

  /* ---------- Country / province selectors (customer addresses) ---------- */
  if (window.Shopify && window.Shopify.CountryProvinceSelector) {
    $$('[data-address-form]').forEach(f => {
      const id = f.dataset.addressForm;
      const c = $('#AddressCountry' + id), p = $('#AddressProvince' + id);
      if (c && p) new window.Shopify.CountryProvinceSelector('AddressCountry' + id, 'AddressProvince' + id, { hideElement: 'AddressProvinceContainer' + id });
    });
  }
})();
